import { createAsyncThunk } from "@reduxjs/toolkit";
import { useHttp } from "../hooks/use-http";

const getAllAnnouncements = createAsyncThunk(
  "announcements/getAll",
  async ({ page }) => {
    const { request } = useHttp();
    return await request({
      url: `/advert/announcement/${page ? `?page=${page}` : ""}`,
    });
  }
);

const getSingleAnnouncement = createAsyncThunk(
  "announcements/getSingle",
  async (id) => {
    const { request } = useHttp();
    return await request({
      url: `/advert/announcement/${id}/`,
    });
  }
);

export { getAllAnnouncements, getSingleAnnouncement };
